import { Component } from '@angular/core';

@Component({
    selector: 'vw-bell-icon',
    imports: [],
    styles: [`:host { display: block; }`],
    template: `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>`
})
export class BellIconComponent {}
